module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Base_04.4a0c93b5.png";